import { useCallback, useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";

import { getAllUpdates } from "../../../../../services/updatesServices";

import {
  DEFAULT_UPDATE_FILTERS,
  calculateUpdatesStats,
  filterUpdates,
  safeArray,
  sortUpdates,
} from "../utils/updatesDashboardUtils";

export function useUpdatesDashboard() {
  const [updates, setUpdates] = useState([]);
  const [loading, setLoading] = useState(true);

  const [filters, setFilters] = useState(DEFAULT_UPDATE_FILTERS);

  const fetchUpdates = useCallback(async () => {
    try {
      setLoading(true);

      const data = await getAllUpdates();
      setUpdates(sortUpdates(safeArray(data), "date_desc"));
    } catch (error) {
      console.error("Erreur chargement mises à jour :", error);
      toast.error("Erreur lors de la récupération des mises à jour.");
      setUpdates([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUpdates();
  }, [fetchUpdates]);

  const filteredUpdates = useMemo(() => {
    return filterUpdates(updates, filters);
  }, [updates, filters]);

  const stats = useMemo(() => calculateUpdatesStats(updates), [updates]);

  const filteredStats = useMemo(
    () => calculateUpdatesStats(filteredUpdates),
    [filteredUpdates]
  );

  const setFilter = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const resetFilters = () => {
    setFilters(DEFAULT_UPDATE_FILTERS);
  };

  return {
    updates,
    filteredUpdates,
    loading,

    filters,
    setFilter,
    resetFilters,

    stats,
    filteredStats,

    fetchUpdates,
  };
}